import c from '@/styles/InstagramArticlesList';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn } from '@/utils/cn';
import { getPropStylesFactory } from '@/utils/getPropStylesFactory';

export interface InstagramArticlesListArticleProps extends ComponentProps<'div'> {
  variant?: ClassNameProp<'default'>;
  colors?: ClassNameProp<'primary'>;
  size?: ClassNameProp<'default'>;
}

export const InstagramArticlesListArticleComponent: Component<InstagramArticlesListArticleProps> = ({
  variant,
  colors,
  size,
  className,
  children,
  ...props
}) => {
  const getPropStyles = getPropStylesFactory(c);

  const variantClassName = getPropStyles('article_variant', variant, 'default');
  const colorClassName = getPropStyles('article_colors', colors, 'primary');
  const sizeClassName = getPropStyles('article_size', size, 'default');

  const componentClassName = cn(variantClassName, colorClassName, sizeClassName, className);

  return (
    <div className={componentClassName} {...props}>
      {children}
    </div>
  );
};
